<template>
  <div>
    <v-row>
      <v-col class="pb-0">
        <span class="subtitle-bold-font">Dispositivos para encaminhamento </span>
        <span
          >({{ localFlowConfiguration.forward_registers.length }}
          {{ localFlowConfiguration.forward_registers.length === 1 ? 'dispositivo configurado' : 'dispositivos configurados' }})</span
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0 pt-1">
        <forward-registers-configuration :forward-registers="localFlowConfiguration.forward_registers" @input="setForwardRegisters" />
        <span v-if="forwardRegistersError" class="pl-3 error--text">{{ forwardRegistersError }}</span>
      </v-col>
    </v-row>

    <v-row>
      <!-- Federative unit selection -->
      <v-col cols="12" class="py-0 pt-3">
        <mf-toggle v-model="localFlowConfiguration.select_federative_unit_message.active" class="pt-0 pb-1 mt-0 pl-1" label="Seleção de estado" hide-details>
          <template v-slot:label>
            <span class="subtitle-bold-font">Seleção de estado</span>
          </template>
        </mf-toggle>
        <mf-textarea-emoji
          v-model="localFlowConfiguration.select_federative_unit_message.message"
          class="textarea"
          outlined
          no-resize
          rows="3"
          hide-counter
          :max-length="0"
          :error-messages="selectFederativeUnitMessageError"
        />
      </v-col>
    </v-row>
    <v-row>
      <!-- City selection -->
      <v-col cols="12" class="py-0 pt-3">
        <mf-toggle v-model="localFlowConfiguration.select_city_message.active" class="pt-0 pb-1 mt-0 pl-1" label="Seleção de estado" hide-details>
          <template v-slot:label>
            <span class="subtitle-bold-font">Seleção de cidade</span>
          </template>
        </mf-toggle>
        <mf-textarea-emoji
          v-model="localFlowConfiguration.select_city_message.message"
          class="textarea"
          outlined
          no-resize
          rows="3"
          hide-counter
          :max-length="0"
          :error-messages="selectCityMessageError"
        />
      </v-col>
    </v-row>

    <!-- Unit selection -->
    <v-row>
      <v-col class="py-0 pt-3">
        <mf-toggle v-model="localFlowConfiguration.select_unit_message.active" class="pt-0 pb-1 mt-0 pl-1" label="Seleção de estado" hide-details>
          <template v-slot:label>
            <span class="subtitle-bold-font">Seleção de loja</span>
          </template>
        </mf-toggle>
        <mf-textarea-emoji
          v-model="localFlowConfiguration.select_unit_message.message"
          class="textarea"
          outlined
          no-resize
          rows="3"
          hide-counter
          :max-length="0"
          :error-messages="selectUnitMessageError"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pb-0">
        <span class="subtitle-bold-font">
          Mensagem de redirecionamento
          <v-tooltip bottom max-width="300px">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <mf-icon class="help-icon" size="18">info</mf-icon>
              </span>
            </template>
            <span>Última mensagem enviada da opção que direciona o usuário para um dos dispositivos previamente configurados para encaminhamento.</span>
          </v-tooltip>
        </span>
        <mf-textarea-emoji
          v-model="localFlowConfiguration.send_contact_message"
          class="textarea"
          outlined
          no-resize
          rows="1"
          hide-counter
          :max-length="0"
          :error-messages="sendContactMessageError"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pb-0">
        <span class="subtitle-bold-font">
          Mensagem de início de conversa com disparador
          <v-tooltip bottom max-width="300px">
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <mf-icon class="help-icon" size="18">info</mf-icon>
              </span>
            </template>
            <span>Mensagem configurada para ser exibida no celular do consumidor ao iniciar uma conversa no dispositivo para encaminhamento.</span>
          </v-tooltip>
        </span>
        <mf-textarea-emoji
          v-model="localFlowConfiguration.start_register_chat_content"
          class="textarea"
          outlined
          no-resize
          rows="1"
          hide-counter
          :max-length="0"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual'
import range from 'lodash/range'
import cloneDeep from 'lodash/cloneDeep'
import { forwardToSenderValidation } from '@/modules/campanhas/whatsapp/validations/flows.js'

export default {
  components: {
    ForwardRegistersConfiguration: () =>
      import('@/modules/campanhas/whatsapp/views/components/flow_configurations/components/ForwardRegistersConfiguration.vue'),
  },
  props: {
    flowConfiguration: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    localFlowConfiguration: {
      forward_registers: [],
    },
  }),
  computed: {
    forwardRegistersError() {
      if (this.$v.localFlowConfiguration?.$error) {
        if (!this.$v.localFlowConfiguration?.forward_registers?.required) return 'Configure um dispositivo para encaminhamento.'
      }
      return ''
    },
    sendContactMessageError() {
      if (this.$v.localFlowConfiguration?.$error) {
        if (!this.$v.localFlowConfiguration?.send_contact_message?.required) return 'Escreva uma mensagem de encaminhamento.'
        if (!this.$v.localFlowConfiguration?.send_contact_message?.minLength) return 'A mensagem possui menos de 2 caracteres.'
        if (!this.$v.localFlowConfiguration?.send_contact_message?.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
        if (!this.$v.localFlowConfiguration?.send_contact_message?.mustHaveString) return 'A mensagem de encaminhamento precisa ter a variável [link].'
      }
      return ''
    },
    selectFederativeUnitMessageError() {
      if (this.$v.localFlowConfiguration?.$error && this.$v.localFlowConfiguration?.select_federative_unit_message?.$error) {
        if (!this.$v.localFlowConfiguration?.select_federative_unit_message?.message?.required) return 'Escreva uma mensagem de seleção de estado.'
        if (!this.$v.localFlowConfiguration?.select_federative_unit_message?.message?.minLength) return 'A mensagem possui menos de 2 caracteres.'
        if (!this.$v.localFlowConfiguration?.select_federative_unit_message?.message?.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
        if (!this.$v.localFlowConfiguration?.select_federative_unit_message?.message?.mustHaveString)
          return 'A mensagem de seleção de estado precisa ter a variável [menu].'
      }
      return ''
    },
    selectCityMessageError() {
      if (this.$v.localFlowConfiguration?.$error && this.$v.localFlowConfiguration?.select_city_message?.$error) {
        if (!this.$v.localFlowConfiguration?.select_city_message?.message?.required) return 'Escreva uma mensagem de seleção de cidade.'
        if (!this.$v.localFlowConfiguration?.select_city_message?.message?.minLength) return 'A mensagem possui menos de 2 caracteres.'
        if (!this.$v.localFlowConfiguration?.select_city_message?.message?.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
        if (!this.$v.localFlowConfiguration?.select_city_message?.message?.mustHaveString)
          return 'A mensagem de seleção de cidade precisa ter a variável [menu].'
      }
      return ''
    },
    selectUnitMessageError() {
      if (this.$v.localFlowConfiguration?.$error && this.$v.localFlowConfiguration?.select_unit_message?.$error) {
        if (!this.$v.localFlowConfiguration?.select_unit_message?.message?.required) return 'Escreva uma mensagem de seleção de loja.'
        if (!this.$v.localFlowConfiguration?.select_unit_message?.message?.minLength) return 'A mensagem possui menos de 2 caracteres.'
        if (!this.$v.localFlowConfiguration?.select_unit_message?.message?.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
        if (!this.$v.localFlowConfiguration?.select_unit_message?.message?.mustHaveString) return 'A mensagem de seleção de loja precisa ter a variável [menu].'
      }
      return ''
    },
  },
  watch: {
    flowConfiguration: {
      deep: true,
      handler(val) {
        if (!isEqual(val, this.localFlowConfiguration)) {
          this.localFlowConfiguration = cloneDeep(val)
          this.setDefaults()
        }
      },
    },

    localFlowConfiguration: {
      deep: true,
      handler(val) {
        if (!isEqual(val, this.flowConfiguration)) {
          this.$emit('input', val)
        }
      },
    },
  },

  created() {
    this.localFlowConfiguration = cloneDeep(this.flowConfiguration)
    this.setDefaults()
    // Rebind new properties
    this.localFlowConfiguration = { ...this.localFlowConfiguration }
  },

  methods: {
    setDefaults() {
      if (!this.localFlowConfiguration.forward_registers?.length) {
        this.localFlowConfiguration.forward_registers = []
      }
      if (!this.localFlowConfiguration.send_contact_message) {
        this.localFlowConfiguration.send_contact_message = 'Recebe as ofertas mandando mensagem no link: [link]'
      }
      if (!this.localFlowConfiguration.start_register_chat_content) {
        this.localFlowConfiguration.start_register_chat_content = ''
      }
      if (!this.localFlowConfiguration.select_federative_unit_message) {
        this.localFlowConfiguration.select_federative_unit_message = {
          active: true,
          message: 'Selecione o estado:\n[menu]\nDigite o número da opção desejada:',
        }
      }

      if (!this.localFlowConfiguration.select_city_message) {
        this.localFlowConfiguration.select_city_message = {
          active: true,
          message: 'Selecione a cidade:\n[menu]\nDigite o número da opção desejada:',
        }
      }

      if (!this.localFlowConfiguration.select_unit_message) {
        this.localFlowConfiguration.select_unit_message = {
          active: true,
          message: 'Selecione a loja:\n[menu]\nDigite o número da opção desejada:',
        }
      }
    },
    computeMessages() {
      const messages = []
      if (this.localFlowConfiguration.select_federative_unit_message?.active) {
        messages.push({
          fromBot: true,
          text: this.fakeMenu(this.localFlowConfiguration.select_federative_unit_message?.message, 'Estado'),
        })
        messages.push({
          fromBot: false,
          text: '1',
        })
      }
      if (this.localFlowConfiguration.select_city_message?.active) {
        messages.push({
          fromBot: true,
          text: this.fakeMenu(this.localFlowConfiguration.select_city_message?.message, 'Cidade'),
        })
        messages.push({
          fromBot: false,
          text: '1',
        })
      }
      if (this.localFlowConfiguration.select_unit_message?.active) {
        messages.push({
          fromBot: true,
          text: this.fakeMenu(this.localFlowConfiguration.select_unit_message?.message, 'Loja'),
        })
        messages.push({
          fromBot: false,
          text: '1',
        })
      }
      let forwardLink = 'https://wa.me/5541999550325'
      if (this.localFlowConfiguration.start_register_chat_content) {
        forwardLink = `${forwardLink}?text=${encodeURIComponent(this.localFlowConfiguration.start_register_chat_content)}`
      }
      messages.push({
        fromBot: true,
        text: this.localFlowConfiguration.send_contact_message.replaceAll('[link]', forwardLink),
      })
      return messages
    },
    fakeMenu(text, label) {
      const options = range(2)
        .map((index) => `${index + 1} - ${label} ${index + 1}`)
        .join('\n')
      return text.replaceAll('[menu]', options)
    },
    setForwardRegisters(forwardRegisters) {
      this.localFlowConfiguration = {
        ...this.localFlowConfiguration,
        forward_registers: forwardRegisters,
      }
    },
    validate() {
      this.$v.$reset()
      this.$v.$touch()
      return this.$v.$error
    },
  },
  validations() {
    return {
      localFlowConfiguration: forwardToSenderValidation(this.localFlowConfiguration),
    }
  },
}
</script>
